'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'diamond-half-stroke';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M38.6 256L280 497.4 280 14.6 38.6 256z', 'M16 256L27.3 267.3 276.7 516.7 288 528 560 256 548.7 244.7 299.3-4.7 288-16 16 256zM280 497.4L38.6 256 280 14.6 280 497.4zm16 0L296 14.6 537.4 256 296 497.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;